var exports = {
  "kL": "xa15a2ab7--b7be43--container",
  "DD": "xa15a2ab7--b7be43--title",
  "Qq": "xa15a2ab7--b7be43--text",
};

module.exports = exports;
